/** Notify hooks (e.g. useIsAdmin) after login/logout in the same tab. */
export function notifyAuthSessionUpdated() {
  window.dispatchEvent(new Event("sundorbon-auth-updated"));
}
